
import {ActivityStatus} from "../model/users/User";

export const activityStatusesToString = new Map<ActivityStatus, string>([
    [ActivityStatus.ACTIVE, 'Активна'],
    [ActivityStatus.BLOCKED, 'Заблокирована']
])